export function LeadForm({
  email,
  whatsapp,
  note,
  status,
  message,
  setEmail,
  setWhatsapp,
  setNote,
  onSubmit
}) {
  return (
    <section className="content-block form-block">
      <span className="section-eyebrow">Study room notes</span>
      <h2>Share where you are stuck</h2>
      <p>Tell us your exam, year and biggest confusion. The site improves around real beginner problems.</p>
      <form className="lead-form" onSubmit={onSubmit}>
        <input
          type="email"
          placeholder="Email address"
          aria-label="Email address"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          disabled={status === "loading"}
          required
        />
        <input
          type="tel"
          placeholder="Optional WhatsApp number"
          aria-label="WhatsApp number"
          value={whatsapp}
          onChange={(event) => setWhatsapp(event.target.value)}
          disabled={status === "loading"}
        />
        <textarea
          placeholder="Example: I am starting CSS from zero and confused about optional subjects."
          aria-label="Preparation notes"
          value={note}
          onChange={(event) => setNote(event.target.value)}
          disabled={status === "loading"}
          rows={4}
        />
        <button type="submit" className="button button-primary button-full" disabled={status === "loading"}>
          {status === "loading" ? "Submitting..." : "Keep me updated"}
        </button>
      </form>
      {message ? (
        <p className={`form-message ${status === "error" ? "error" : "success"}`}>{message}</p>
      ) : null}
    </section>
  );
}
